import { render } from "./TheHero.vue?vue&type=template&id=694ba79a"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"

import "./TheHero.vue?vue&type=style&index=0&id=694ba79a&lang=css"

import exportComponent from "/github/workspace/vueapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__